export const INVALID_PROMO_LINK_MESSAGE = 'Ссылка на промо недействительна.';

export function isInvalidPromoLinkMessage(message: string | null | undefined): boolean {
  if (!message) {
    return false;
  }
  return (
    message === INVALID_PROMO_LINK_MESSAGE ||
    message.includes('недействительн')
  );
}

const INTERNAL_AUTH_ERRORS = new Set([
  'bot token not configured',
  'invalid telegram authorization',
  'missing telegram authorization header',
  'empty telegram authorization header',
  'invalid telegram user data',
  'authorization error',
]);

export function toUserFacingPromoError(
  message: string | undefined,
  status?: number,
  errorCode?: string
): string {
  if (status === 401 && errorCode === 'SESSION_EXPIRED') {
    return message || 'Сеанс истек. Необходимо перезапустить приложение.';
  }

  if (status === 401 || status === 403) {
    return INVALID_PROMO_LINK_MESSAGE;
  }

  const normalized = message?.trim().toLowerCase() ?? '';
  if (INTERNAL_AUTH_ERRORS.has(normalized)) {
    return INVALID_PROMO_LINK_MESSAGE;
  }

  return message || INVALID_PROMO_LINK_MESSAGE;
}
